<div
  (waResizeObserver)="updateDimensions()"
  class="pointer-events-none absolute top-0 right-0 bottom-0 left-0"></div>

@let _dimension = dimension();
@if (_dimension) {
  @let ping = pingedWord();
  @for (word of foundWords(); track $index) {
    @if (word !== ping) {
      <div
        #fieldHighlight
        class="bg-theme-blue/40 absolute"
        [ngStyle]="word | toWordRect | scaleRect: _dimension | rectDisplayStyle"></div>
    }
  }
  <div
    #pingElement
    [ngClass]="{ hidden: ping === undefined || ping.pageId !== pageId() }"
    #fieldHighlight
    class="absolute bg-purple-700/50"
    [ngStyle]="ping | toWordRect | scaleRect: _dimension | rectDisplayStyle"></div>
}
